var map = {
	"./city/new/index-bg-basic.jpg": 54651,
	"./city/new/index-bg-basic2.jpg": 89781,
	"./city/new/index-bg-basic3.jpg": 44501,
	"./city/new/index-bg-basic4.jpg": 71694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33630;